export const getTagName = (selectedTagId, options) => {
  if (options) {
    for (let i = 0; i < options.length; i += 1) {
      if (options[i].id === selectedTagId) {
        return options[i].name;
      }
    }
  }
  return '';
};

export default {};
